<template>
  <a-modal
    title="导入Excel"
    :visible="excelVisible"
    @ok="importExcelHandleCancel"
    @cancel="importExcelHandleCancel"
  >
    <div class="btn">
      <a-button @click="onDownloadTemplate">下载模板</a-button>
    </div>
    <a-upload-dragger
      name="file"
      accept=".xlsx, .xls"
      :multiple="true"
      :headers="upload.headers"
      :action="upload.url + '?ids=' + this.ids"
      @change="importExcelHandleChange"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        请将文件拖拽到此处上传
      </p>
      <p class="ant-upload-hint">
        支持单个或批量上传，也可以点击后选择文件上传
      </p>
    </a-upload-dragger>
  </a-modal>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'ImportExcel',
  data() {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      ids: '', // 勾选数据数组
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpCallManager/importCallNotice'
      },
      excelVisible: false // 导入excel
    }
  },
  methods: {
    // 下载模板
    onDownloadTemplate() {
      console.log('下载模板')
      const url = 'https://gyl-lsprtgallery.oss-cn-shenzhen.aliyuncs.com/20240716/%E5%8F%AB%E6%96%99%E9%80%9A%E7%9F%A5%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx';
      const link = document.createElement('a');
      link.href = url;
      link.download = `叫料通知导入模板_${new Date().getTime()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    show(ids) {
      if (ids?.length > 0) {
        this.ids = ids.join(',')
      }
      this.excelVisible = true;
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel () {
      this.excelVisible = false
      this.$emit('refresh')
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    }
  }
}
</script>

<style lang='less' scoped>
.btn{
  margin-bottom: 20px;
}

</style>
